import { requestJson } from "./instateamEmployeeApi";

export function getEmployeeComplaints(token) {
  return requestJson("/instateam/complaints/employee", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createEmployeeComplaint(token, payload) {
  return requestJson("/instateam/complaints/employee", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
